import { useState } from "react";
import Icon from "../Icon";
import DatePicker from "./DatePicker";
import { Avatar, ModalFt } from "../Atoms";
import { PJ_ESTADOS_PROYECTO, PJ_PRIOS, PJ_ROLES, AG_TIPO_PALETTE } from "../../constants";
import Campo from "./Campo";
import { colorNombre, iconoNombre } from "../../colorNombre";

const ICONOS = ["diagram-3","kanban-fill","folder2-open","people-fill","graph-up-arrow",
  "clock","journal-text","shield-check","headset","calendar3"];

// Crear o editar un proyecto. El backend recomprueba todo: aqui no se decide
// ningun permiso, solo se recogen los datos.
export default function ProyectoForm({ proyecto, teams = [], users = [], currentUser, inS, lbS, onSave, onClose }) {
  const ed = !!proyecto;
  const [f, setF] = useState({
    name:        proyecto?.name || "",
    description: proyecto?.description || "",
    start_date:  proyecto?.start_date || "",
    end_date:    proyecto?.end_date || "",
    team_id:     proyecto?.team_id || "",
    estado:      proyecto?.estado || "activo",
    prioridad:   proyecto?.prioridad || "Media",
    color:       proyecto?.color || "#3b82f6",
    icon:        proyecto?.icon || "diagram-3",
    owner_id:    proyecto?.owner_id || currentUser?.id || "",
  });
  // Solo al crear: a quien se mete en el proyecto de entrada. Al editar, el
  // equipo se gestiona desde la propia pagina del proyecto.
  const [miembros, setMiembros] = useState([]);

  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  const fechasAlReves = f.start_date && f.end_date && f.end_date < f.start_date;
  const valido = f.name.trim() && !fechasAlReves;

  const alternarMiembro = (uid, rol) => setMiembros(prev => {
    const otros = prev.filter(m => String(m.user_id) !== String(uid));
    const actual = prev.find(m => String(m.user_id) === String(uid));
    // Pulsar el papel que ya tenia lo quita del proyecto.
    return actual && actual.rol === rol ? otros : [...otros, { user_id: String(uid), rol }];
  });

  const guardar = () => {
    if (!valido) return;
    onSave({
      name: f.name.trim(),
      description: f.description.trim() || null,
      start_date: f.start_date || null,
      end_date: f.end_date || null,
      team_id: f.team_id || null,
      estado: f.estado,
      prioridad: f.prioridad,
      color: f.color,
      icon: f.icon,
      owner_id: f.owner_id || null,
      ...(ed ? {} : { miembros }),
    });
  };

  return (
    <div>
      <div data-titulo="1" style={{ fontWeight: 800, fontSize: 16, marginBottom: 16, color: "var(--text)" }}>
        {ed ? "Editar proyecto" : "Nuevo proyecto"}
      </div>

      <Campo><label style={lbS}>Nombre</label>
      <input style={inS} value={f.name} autoFocus
        onChange={e => set("name", e.target.value)}
        placeholder="Migracion del servidor, campaña de otoño..." /></Campo>

      <Campo><label style={lbS}>Descripcion</label>
      <textarea style={{ ...inS, minHeight: 62, resize: "vertical" }} value={f.description}
        onChange={e => set("description", e.target.value)}
        placeholder="Que se quiere conseguir, y por que" /></Campo>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <div>
          <Campo><label style={lbS}>Fecha de inicio</label>
          <DatePicker value={f.start_date} nombre="Fecha de inicio"
            placeholder="Sin fecha" margenInferior={0}
            onChange={v => set("start_date", v)} /></Campo>
        </div>
        <div>
          <Campo><label style={lbS}>Fecha de fin prevista</label>
          <DatePicker value={f.end_date} nombre="Fecha de fin prevista"
            placeholder="Sin fecha" margenInferior={0} invalido={fechasAlReves}
            refDate={f.start_date}
            onChange={v => set("end_date", v)} /></Campo>
        </div>
      </div>
      {fechasAlReves && (
        <div style={{ fontSize: 11, color: "var(--red-text)", marginTop: -6, marginBottom: 10 }}>
          La fecha de fin es anterior a la de inicio.
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <div>
          <Campo><label style={lbS}>Estado</label>
          <select style={{ ...inS, cursor: "pointer" }} value={f.estado}
            onChange={e => set("estado", e.target.value)}>
            {PJ_ESTADOS_PROYECTO.map(e => <option key={e.key} value={e.key}>{e.label}</option>)}
          </select></Campo>
        </div>
        <div>
          <Campo><label style={lbS}>Prioridad</label>
          <select style={{ ...inS, cursor: "pointer" }} value={f.prioridad}
            onChange={e => set("prioridad", e.target.value)}>
            {PJ_PRIOS.map(p => <option key={p} value={p}>{p}</option>)}
          </select></Campo>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <div>
          {/* Los equipos hacen de departamentos, como en Vacaciones. Es lo que
              usa el backend para decidir que puede tocar un admin. */}
          <Campo><label style={lbS}>Departamento responsable</label>
          <select style={{ ...inS, cursor: "pointer" }} value={f.team_id}
            onChange={e => set("team_id", e.target.value)}>
            <option value="">Sin departamento</option>
            {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select></Campo>
        </div>
        <div>
          <Campo><label style={lbS}>Quien lo lleva</label>
          <select style={{ ...inS, cursor: "pointer" }} value={f.owner_id}
            onChange={e => set("owner_id", e.target.value)}>
            {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select></Campo>
        </div>
      </div>

      <Campo><label style={lbS}>Color e icono</label>
      <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 9 }}>
        {AG_TIPO_PALETTE.map(c => (
          <button key={c} onClick={() => set("color", c)} title={colorNombre(c)} aria-label={"Color " + colorNombre(c)} aria-pressed={f.color === c} className="btn"
            style={{ width: 22, height: 22, borderRadius: 6, background: c, cursor: "pointer",
              border: f.color === c ? "2px solid var(--text)" : "1px solid var(--border)" }} />
        ))}
      </div></Campo>
      <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 13 }}>
        {ICONOS.map(ic => (
          <button key={ic} onClick={() => set("icon", ic)} title={iconoNombre(ic)} aria-label={"Icono " + iconoNombre(ic)} aria-pressed={f.icon === ic} className="btn"
            style={{ width: 28, height: 28, borderRadius: 7, cursor: "pointer",
              background: f.icon === ic ? f.color + "20" : "var(--surface2)",
              border: `1px solid ${f.icon === ic ? f.color : "var(--border)"}`,
              display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon name={ic} size={13} color={f.icon === ic ? f.color : "var(--text3)"} />
          </button>
        ))}
      </div>

      {!ed && (
        <>
          <Campo><label style={lbS}>Quien participa (opcional)</label>
          <div style={{ fontSize: 10.5, color: "var(--text3)", marginBottom: 7, lineHeight: 1.5 }}>
            Pulsa un papel para asignarlo, y el mismo otra vez para quitarlo. Quien lleva el
            proyecto entra como encargado automaticamente.
          </div></Campo>
          <div style={{ maxHeight: 176, overflowY: "auto", border: "1px solid var(--border)",
            borderRadius: 9, marginBottom: 13 }}>
            {users.filter(u => String(u.id) !== String(f.owner_id)).map(u => {
              const m = miembros.find(x => String(x.user_id) === String(u.id));
              return (
                <div key={u.id} style={{ display: "flex", alignItems: "center", gap: 8,
                  padding: "6px 9px", borderBottom: "1px solid var(--border2)" }}>
                  <Avatar name={u.name} size={22} />
                  <span style={{ flex: 1, fontSize: 12, color: "var(--text2)" }}>{u.name}</span>
                  {PJ_ROLES.map(r => (
                    <button key={r.key} className="btn" title={r.sub}
                      onClick={() => alternarMiembro(u.id, r.key)}
                      style={{ padding: "3px 7px", borderRadius: 6, fontSize: 10, cursor: "pointer",
                        fontFamily: "var(--font)", fontWeight: m?.rol === r.key ? 700 : 500,
                        border: `1px solid ${m?.rol === r.key ? "var(--accent)" : "var(--border)"}`,
                        background: m?.rol === r.key ? "var(--accent-bg)" : "var(--surface)",
                        color: m?.rol === r.key ? "var(--accent)" : "var(--text3)" }}>
                      {r.label}
                    </button>
                  ))}
                </div>
              );
            })}
          </div>
        </>
      )}

      <ModalFt onClose={onClose} onSave={guardar} disabled={!valido}
        label={ed ? "Guardar" : "Crear proyecto"} />
    </div>
  );
}
